module.exports = __webpack_public_path__ + "img/rectangle_all.8cdbf565.png";